import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useLocalizationStore = defineStore('localization', () => {
  const locale = ref('en');
  const messages = ref<Record<string, string>>({});
  const isLoading = ref(false);
  const profileId = ref('');
  const apiEndpoint = ref('');

  // Computed
  const currentLocale = computed(() => locale.value);

  // Actions
  async function loadLocale(lang: string): Promise<void> {
    if (isLoading.value) return;
    
    isLoading.value = true;
    try {
      const data = await import(`@/assets/lang/${lang}.json`);
      messages.value = data.default;
      locale.value = lang;
    } catch (error) {
      console.error(`Failed to load locale: ${lang}`, error);
      // Fallback to English if loading fails
      if (lang !== 'en') {
        isLoading.value = false;
        await loadLocale('en');
        return;
      }
    } finally {
      isLoading.value = false;
    }
  }

  function k(key: string): string {
    return messages.value[key] || key;
  }

  function setProfileId(id: string): void {
    profileId.value = id;
  }

  function setApiEndpoint(endpoint: string): void {
    apiEndpoint.value = endpoint;
  }

  function getApiEndpoint(): string {
    if (apiEndpoint.value) {
      return apiEndpoint.value;
    }
    // Default to current host
    return `//${window.location.host}/ui`;
  }

  function getProfileId(): string {
    return profileId.value;
  }

  return {
    // State
    locale,
    messages,
    isLoading,
    profileId,
    apiEndpoint,
    // Computed
    currentLocale,
    // Actions
    loadLocale,
    k,
    setProfileId,
    setApiEndpoint,
    getApiEndpoint,
    getProfileId,
  };
});

